/**
 * Bảo vệ tuyến theo quyền.
 *
 * Không có quyền thì hiển thị `TrangKhongCoQuyen` NGAY TẠI tuyến đó, giữ nguyên
 * đường dẫn. Cố ý không chuyển hướng: chuyển hướng làm người dùng tưởng đường dẫn
 * bị sai, còn trang trắng thì không nói được gì cả.
 */
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { dungPhien } from '../trang-thai/ngu-canh-phien';
import { TrangKhongCoQuyen } from '../trang/TrangKhongCoQuyen';

export interface BaoVeTuyenProps {
  quyen: string;
  children: ReactNode;
}

/**
 * Khu quản trị chỉ dành cho tài khoản cấp tỉnh: tài khoản xã bị chặn dù nhóm có quyền trùng
 * (ví dụ `signage.manage` của Lãnh đạo xã trùng quyền mở MH-25 Quản trị bảng điện tử).
 * Hồ sơ cá nhân và phiên (`/quan-tri/ho-so`, `/quan-tri/phien`) không đi qua BaoVeTuyen.
 */
export const TIEN_TO_CHI_CAP_TINH = ['/quan-tri', '/danh-muc', '/tich-hop'];

function laDuongChiCapTinh(duongDan: string): boolean {
  return TIEN_TO_CHI_CAP_TINH.some((g) => duongDan === g || duongDan.startsWith(`${g}/`));
}

export function BaoVeTuyen({ quyen, children }: BaoVeTuyenProps): ReactNode {
  const { coQuyen, khoaDiaBan } = dungPhien();
  const { pathname } = useLocation();
  if (!coQuyen(quyen) || (khoaDiaBan && laDuongChiCapTinh(pathname))) {
    return <TrangKhongCoQuyen quyenCan={quyen} />;
  }
  return <>{children}</>;
}
